export default "__VITE_ASSET__CUtzUWwH__"